import { useEffect, useState } from "react";
import client from "@/lib/api";
import { Megaphone, X } from "@phosphor-icons/react";

const STYLES = {
  info: "border-sky-400/30 bg-sky-500/[0.08] text-sky-100",
  warning: "border-gold/40 bg-gold/[0.10] text-[#F2D06B]",
  critical: "border-red-500/40 bg-red-500/[0.12] text-red-200",
};

// App-wide announcement banner. Polls the active broadcast and stays dismissed
// (per broadcast id) via localStorage so a member isn't nagged after they close it.
export function BroadcastBanner() {
  const [bc, setBc] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => client.get("/broadcast").then((r) => { if (alive) setBc(r.data?.active ? r.data : null); }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  if (!bc || !bc.active) return null;
  if (localStorage.getItem(`bc_dismissed_${bc.id}`)) return null;
  const cls = STYLES[bc.level] || STYLES.info;
  return (
    <div data-testid="broadcast-banner" className={`mb-5 flex items-center gap-3 rounded-[12px] border px-4 py-3 ${cls}`}>
      <Megaphone size={18} weight="fill" className="shrink-0" />
      <p className="flex-1 text-[13px] font-medium">
        {bc.message}
        {bc.link && <a href={bc.link} target="_blank" rel="noreferrer" className="ml-2 underline underline-offset-2" data-testid="broadcast-banner-link">Learn more</a>}
      </p>
      <button onClick={() => { localStorage.setItem(`bc_dismissed_${bc.id}`, "1"); setBc(null); }}
        data-testid="broadcast-banner-dismiss" className="shrink-0 rounded-full p-1 opacity-70 hover:opacity-100"><X size={16} /></button>
    </div>
  );
}
